import {userConstants} from '../../_constants';

export function deleteCartItems(state = {}, action) {
  switch (action.type) {
    case userConstants.DELETE_ITEMS_FROM_CART_REQUEST:
      return {
        loading: true,
        items: [...action.items],
      };
    case userConstants.DELETE_ITEMS_FROM_CART_SUCCESS:
      return {
        ...action.data,
      };
    case userConstants.DELETE_ITEMS_FROM_CART_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
